import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Read-only label/value pair (Figma "Info block"). Label sits above the value,
 * left-aligned. The value can be passed via [value] or projected as content
 * (e.g. a status chip / link). Long single-line values truncate with a native
 * title tooltip; pass [multiline]="true" to let the value wrap instead.
 */
@Component({
    selector: 'lib-anc-info-block',
    imports: [CommonModule, TranslateModule],
    templateUrl: './anc-info-block.component.html',
    styleUrls: ['./anc-info-block.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncInfoBlockComponent {
    /** Field label (run through translate). 12/16, neutral-medium. */
    label = input<string>('');
    /** Read-only value. 14/22, neutral-high. Falls back to '-' when empty. */
    value = input<string>('');
    /** Renders the required asterisk after the label. */
    required = input<boolean>(false);
    /** Let the value wrap across lines instead of truncating. */
    multiline = input<boolean>(false);
    /** Bidi direction for the value (e.g. ltr for phone numbers and emails). */
    valueDir = input<'ltr' | 'rtl' | 'auto' | null>(null);
}
